import { MarkType } from 'prosemirror-model'
import { TextSelection, Transaction } from 'prosemirror-state'
import { EditorView } from 'prosemirror-view'

import { MarkTypeKey } from '@showrunner/codex'
import { schema } from '@showrunner/prose-schemas'

const removeMark = ({
  tr,
  selection,
  markType,
}: {
  tr: Transaction
  selection: TextSelection
  markType: MarkType
}) =>
  selection.empty
    ? tr.removeStoredMark(markType)
    : tr.removeMark(selection.from, selection.to, markType)

const addMark = ({
  color,
  tr,
  selection,
  markType,
}: {
  color: string
  tr: Transaction
  selection: TextSelection
  markType: MarkType
}) => {
  const pendingMark = markType.create({ color })
  return selection.empty
    ? tr.addStoredMark(pendingMark)
    : tr.addMark(selection.from, selection.to, pendingMark)
}

export const updateMark = ({
  color,
  editorView,
  mark,
}: {
  color: string
  editorView: EditorView
  mark: MarkTypeKey
}) => {
  const markType = schema.marks[mark]

  const { state } = editorView
  const { selection, tr } = state

  if (!(selection instanceof TextSelection)) return

  const shouldRemoveMark = color === ''

  shouldRemoveMark
    ? removeMark({ tr, selection, markType })
    : addMark({ tr, selection, color, markType })

  editorView.dispatch(tr)
}
